import { ShopifyDisputeDetailSchema } from "@redotech/redo-model/disputes/shopify-dispute";
import * as z from "zod/v4";

export const getShopifyDispute = {
  name: "getShopifyDispute" as const,
  input: z.object({ disputeId: z.string() }),
  output: z.object({ dispute: z.nullable(ShopifyDisputeDetailSchema) }),
};
